import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getBannersV2} from '../../services/getBannersV2';
import {GetBannersV2Request} from 'domain/usecases/private/home/banners-v2';

export const useGetBannersV2Query = (params: GetBannersV2Request) =>
	useQuery({
		queryKey: [QUERY_KEYS.BANNERS, params],
		queryFn: ({signal}) => getBannersV2({...params, signal}),
		enabled: !!params.context,
	});
